import { InspectionItem } from '@editor/interfaces/inspection'
import {
  batchDeleteInspectionItems,
  patchInspectionItems as patchInspectionItemsApi,
} from '@editor/services/InspectionSheet'
import { createAsyncThunk } from '@reduxjs/toolkit'

/**
 * Update inspection items.
 */
export const patchInspectionItems = createAsyncThunk(
  'inspectionItems/patch',
  async ({
    accessToken,
    projectId,
    items,
    showErrorModal,
  }: {
    accessToken: string
    projectId: string
    items: Partial<InspectionItem>[]
    showErrorModal?: (message: string) => void
  }) => patchInspectionItemsApi(accessToken, projectId, items, showErrorModal),
)

/**
 * Delete inspection items.
 */
export const deleteInspectionItems = createAsyncThunk(
  'inspectionItems/delete',
  async ({
    accessToken,
    projectId,
    areaId,
    sheetId,
    items,
    showErrorModal,
  }: {
    accessToken: string
    projectId: string
    areaId: string
    sheetId: string
    items: string[]
    showErrorModal?: (message: string) => void
  }) => batchDeleteInspectionItems(accessToken, projectId, areaId, sheetId, items, showErrorModal),
)
